<!-- LanguageSwitch.vue -->
<template>
  <Transition name="fade">
    <div
      v-if="showLang"
      class="fix fade-element"
      @click="showLang = false"
    ></div>
  </Transition>
  <div
    class="lang"
    :class="[deviceType(), type, sort]"
  >
    <div
      class="active"
      @click="showLang = !showLang"
    >
      <div
        v-if="showLang"
        class="away"
      ></div>
      <div
        v-if="!showLang"
        class="expand"
      ></div>
      {{lang}}
    </div>

    <Transition name="fade">
      <div
        class="langs"
        v-if="showLang"
      >
        <p @click="changeLanguage('en', 'en_US')">EN</p>
        <p
          v-if="!isNa"
          @click="changeLanguage('th', 'th_TH')"
        >
          TH
        </p>
        <p @click="changeLanguage('cn', 'cn_TW')">CN</p>
        <p
          v-if="type !== projectType().name"
          @click="changeLanguage('id', 'id-ID')"
        >
          ID
        </p>
        <p
          v-if="type !== projectType().name"
          @click="changeLanguage('vn', 'vi-VN')"
        >
          VN
        </p>
      </div>
    </Transition>
  </div>

</template>

  <script setup>
// cookies的使用
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

import { xhSet } from "../util/xhCookie";

import { projectType } from "../util/global";

import { deviceType } from "@/util/base";

// const emits = defineEmits(["language-change"]);

import { defineProps, ref, computed } from "vue";

defineProps(["type", "sort"]);
const isNa = computed(() => projectType().area.indexOf("na") !== -1);
const showLang = ref(false);

// Define a ref for lang
const lang = ref(cookies.get("XH-WEB")?.page_lang.toUpperCase());
const changeLanguage = (langName, fb_lang) => {
  lang.value = langName;
  xhSet("XH-WEB", {
    page_lang: langName,
    fb_lang: fb_lang,
  });
  location.reload();
};

const slide = ref(true);
const scrollToTop = () => {
  const scrollTops =
    document.documentElement.scrollHeight / document.documentElement.scrollTop;
  if (scrollTops < 4.5 && deviceType() !== "wap") {
    slide.value = false;
  } else {
    slide.value = true;
  }
};
window.addEventListener("scroll", scrollToTop);
</script>
  
<style lang=scss scoped>
.lang {
  position: absolute;
  top: 0.15rem;
  right: 1.5rem;
  z-index: 1000;
  &.wap {
    right: 1.2rem;
  }
  &.pcgw {
    top: 0.05rem;
    right: 2rem;
  }
  &.wapgw {
    top: 1.1rem;
    right: 0.15rem;
  }
  .active {
    width: 1.5rem;
    height: 0.5rem;
    line-height: 0.7rem;
    padding: 0 0.1rem 0 0.55rem;
    font-size: 0.3rem;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  }
  .langs {
    width: 1.5rem;
    border-radius: 0.15rem;
    text-align: center;
    font-size: 0.24rem;
    line-height: 0.35rem;
    p {
      cursor: pointer;
    }
  }
}

.lang {
  // 冒险归来
  &.zth,
  &.nazth {
    .active {
      color: #375c6b;
      background: url("../pages/zth/assets/images/lang.png") no-repeat center;
      background-size: 100% auto;
      .away {
        width: 0.2rem;
        height: 0.2rem;
        background: url("../pages/zth/assets/images/icon-away.png") no-repeat
          center;
        background-size: 100% auto;
      }
      .expand {
        width: 0.2rem;
        height: 0.2rem;
        background: url("../pages/zth/assets/images/icon-expand.png") no-repeat
          center;
        background-size: 100% auto;
      }
    }
    .langs {
      background: #baf0e7;
      border: 2px solid #2588b0;
      color: #375c6b;
      p {
        border-bottom: 2px solid #2588b0;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  &.wap {
    .langs {
      line-height: 0.6rem;
    }
  }
}
</style>
